import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerAppIcons } from './app/core/icons/app-icons';

// crypto.randomUUID() requires a secure context (HTTPS or localhost); crypto.getRandomValues()
// does not. Keycloak's createLoginUrl() calls randomUUID() unconditionally for state/nonce, which
// breaks login when served over plain HTTP on a non-localhost origin (e.g. http://10.100.18.56:4200).
// TODO: remove this polyfill once the app is served over HTTPS.
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = () => {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}` as ReturnType<Crypto['randomUUID']>;
  };
}

registerAppIcons();

bootstrapApplication(App, appConfig).catch(err => console.error(err));
